import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const UserRedirectIfAuth = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user ? <Navigate to="/user/dashboard" replace /> : <Outlet />;
};

export default UserRedirectIfAuth;